
export const lst_tipo_impuesto = [
    { id: 1, nombre: "18%", value: 18 },
    { id: 2, nombre: "10% (Ley 31556)", value: 10 },
    { id: 3, nombre: "10.5% (Ley 31556 y 32387)", value: 10.5 }
]


